/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/default-props-match-prop-types */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Autocomplete from 'react-autocomplete';
import classnames from 'classnames';
import { withTranslation } from 'react-i18next';
import { Avatar } from '../user/Avatar';

function renderDriver(driver, isHighlighted, t) {
  const driverItemClassName = classnames({
    'driver-item': true,
    highlighted: isHighlighted,
  });

  return (
    <div className={driverItemClassName}>
      <Avatar
        key={driver._id}
        userId={driver._id}
        altName={driver.fullName}
        style={{ width: 20, height: 20 }}
      />
      <span>
        {driver.fullName} ({t('VEHICLE')}:{' '}
        {driver.equipmentClassLabel &&
        !driver.equipmentClassLabel.toLowerCase().includes('unknown')
          ? t(driver.equipmentClassLabel)
          : t('UNKNOWN')}
        )
      </span>
      <span>{driver.status}</span>
    </div>
  );
}

function mapDriverProps(props) {
  const input = props.value;
  return (
    props.drivers.filter((d) => {
      return d.fullName.toLowerCase().includes(input.toLowerCase());
    }) || []
  );
}

class DriverAutocomplete extends Component {
  constructor(props) {
    super(props);
    this.state = {
      drivers: mapDriverProps(props),
    };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    const drivers = mapDriverProps(nextProps);
    this.setState({
      drivers,
    });
  }
  handleChange = (e) => {
    const input = e.target.value || '';

    const drivers = this.state.drivers.filter((d) =>
      d.fullName.toLowerCase().includes(input.toLowerCase()),
    );

    this.setState({
      drivers,
    });

    this.props.onChange(input);
  };
  render() {
    const { t } = this.props;
    return (
      <Autocomplete
        menuStyle={{
          backgroundColor: 'white',
          maxHeight: 200,
          minWidth: 400,
          zIndex: 35,
          left: 0,
          top: 37,
          position: 'absolute',
          overflowY: 'scroll',
        }}
        wrapperStyle={{
          position: 'relative',
        }}
        renderItem={(driver, isHighlighted) => {
          return renderDriver(driver, isHighlighted, t);
        }}
        getItemValue={(item) => item.fullName}
        value={this.props.value}
        onChange={this.handleChange}
        inputProps={{
          placeholder: t('CLICK_TO_SELECT_DRIVER'),
          className:
            'w-full shadow appearance-none border rounded py-2 px-3 text-grey-darker',
        }}
        onSelect={(value, driver) => {
          this.props.onDriverSelected({ value, driver });
        }}
        items={this.state.drivers}
      />
    );
  }
}

DriverAutocomplete.propTypes = {
  value: PropTypes.string.isRequired,
  // eslint-disable-next-line
  drivers: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  onDriverSelected: PropTypes.func.isRequired,
};

export default withTranslation()(DriverAutocomplete);
